import {makeStyles} from "@material-ui/core";
import {useSelector} from "react-redux";
import {useEffect, useState} from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: 44,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
    borderRadius: 10,
    cursor: 'pointer'
  },
  expandedRoot: {
    height: 'unset',
    flexDirection: 'column'
  },
  title: {
    fontFamily: 'Spartan-bold',
    fontSize: 20,
    color: '#017AEF',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  arrowIcon: {
    width: 12,
    height: 12
  },
  grey: {
    color: '#606B76'
  },
  projectsPanel: {
    marginTop: 30
  },
  projectTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    color: '#606B76'
  },
  projectCreateIcon: {
    cursor: 'pointer'
  },
  folder: {
    display: 'flex',
    alignItems: 'center',
    height: 35,
    cursor: 'pointer!important'
  },
  folderName: {
    fontSize: 14,
    fontFamily: 'roboto-bold',
    color: '#697683',
    margin: '0 0 0 8px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  projectDiv: {
    width: '100%',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    borderTop: '1px solid #F5F5F5',
    fontFamily: 'Spartan-bold',
    fontSize: 20,
    color: '#697683'
  },
  selectProject: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

  const MobileProjects = (props: any) => {
  const classes = useStyles();
  const { onSelectProject, reelsLength } = props;
  const { projects } = useSelector((state: any) => state.creatorDashboard);
  const [isExpanded, setIsExpanded] = useState(false);
  const [projectName, setProjectName] = useState('All Experiences');
  const [batchAsyncRole, setBatchAsyncRole] = useState(false);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  useEffect(() => {
    if (loginUserData && loginUserData.role_access) {
      if (loginUserData.role_access.length) {
        const batch_async = loginUserData.role_access.filter((val:any) => val.access_name === "batch_async");
        if (batch_async.length > 0 && batch_async[0].access_value) {
          setBatchAsyncRole(true)
        }
      }
    }
  }, []);

  return (
    <>
      {isExpanded ? 
      (
        <div className={clsx(classes.root, classes.expandedRoot)}>
          <div className={classes.selectProject} onClick={() => setIsExpanded(!isExpanded)}>
            <p
              className={classes.title}
            >
              Select Project
            </p>
            <img
              src={'/assets/icons/dashboard/dropdown.svg'}
              alt={'img'}
              className={classes.arrowIcon}
            />
          </div>
          <div
            className={classes.projectDiv}
            onClick={() => {
              setProjectName('All Experiences');
              onSelectProject(-1);
              setIsExpanded(false);
            }}
          >
            All Experiences
          </div>
          {
            (batchAsyncRole && reelsLength > 0) && 
            (<div 
              className={classes.projectDiv} 
              onClick={()=>{
                onSelectProject(-2);
                setProjectName('Reels');
                setIsExpanded(false);
              }}
            >
              Reels
            </div>
          )}
          {projects.map((project: any, index: number) => (
            <div
              key={index}
              className={classes.projectDiv}
              onClick={() => {
                setProjectName(project.projectName);
                onSelectProject(project.projectId);
                setIsExpanded(false);
              }}
            >
              {project.projectName}
            </div>
          ))}
        </div>
      ) : (
        <div className={classes.root} onClick={() => setIsExpanded(true)}>
          <p
            className={classes.title}
          >
            {projectName}
          </p>
          <img
            src={'/assets/icons/dashboard/mobile-project-arrow.svg'}
            alt={'img'}
            className={classes.arrowIcon}
          />
        </div>
      )}
    </>
  )
};

export default MobileProjects;